module.exports = __webpack_public_path__ + "img/ic_16_delete_filled.b642dfa0.svg";